import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";
import { DropPhotoCta } from "./DropPhotoCta";
import { Reveal } from "./Reveal";

// Section E — the close. A golden-hour band bookends the hero (the warmth lives
// in the imagery, never a cream chrome wash) and repeats the one action: drop a
// photo. No re-mounted Stage here; the decision is the point, not more spectacle.
const GOLDEN_HOUR_BG =
  "radial-gradient(120% 100% at 50% 0%, #f6dfba 0%, #eedfc6 52%, #e7ddca 100%)";

export function ClosingCta() {
  const { t } = useTranslation("landing");
  return (
    <section id="start" aria-labelledby="closing-heading" className="relative overflow-hidden">
      <div aria-hidden="true" className="absolute inset-0" style={{ background: GOLDEN_HOUR_BG }} />
      <div className="relative mx-auto max-w-3xl px-6 py-[clamp(4.5rem,9vw,8rem)] text-center sm:px-8">
        <Reveal>
          <h2
            id="closing-heading"
            className="text-balance font-display text-[clamp(1.9rem,1.2rem+2.6vw,2.75rem)] font-semibold leading-[1.12] tracking-tight text-foreground"
          >
            {t("closing.heading")}
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-pretty text-lg leading-relaxed text-foreground/80">
            {t("closing.body")}
          </p>
          <div className="mt-8 flex justify-center">
            <DropPhotoCta
              label={t("closing.cta")}
              className="min-h-13 px-9 text-base shadow-lg shadow-primary/25"
              testId="closing-cta"
            />
          </div>
          <ClosingReassurance />
        </Reveal>
      </div>
    </section>
  );
}

function ClosingReassurance() {
  const { t } = useTranslation("landing");
  const items = t("closing.reassurance", { returnObjects: true });
  if (!Array.isArray(items)) return null;
  return (
    <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2">
      {(items as string[]).map((item) => (
        <li key={item} className="flex items-center gap-2 text-sm text-foreground/70">
          <Check className="h-4 w-4 shrink-0 text-primary" aria-hidden="true" />
          {item}
        </li>
      ))}
    </ul>
  );
}
